import React from "react";

import PageWrapper from "./src/components/PageWrapper";

export function wrapRootElement({ element }, pluginOptions) {
  return <PageWrapper pluginOptions={pluginOptions}>{element}</PageWrapper>;
}
